<template>
  <div class="ai-writer-info-footer">
    <div class="d-flex">
      <!-- Save controls (main content editor .bottom-area semantics: the Save
           button doubles as the dirty indicator). -->
      <div class="flex-grow-1 d-flex align-center" style="gap: 10px;">
        <button type="button" class="wg-save-btn" :class="{ saved: !needsToSave }" @click="$emit('save')">
          <span v-if="needsToSave" class="dirty-dot">!</span>
          <svg v-else viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
          {{ needsToSave ? 'Save' : 'Saved!' }}
        </button>
        <button type="button" class="wg-soft-btn" @click="$emit('save-revision')">
          <i class="material-icons-outlined" style="font-size: 1rem;">history</i>
          Save revision
        </button>
      </div>
      <div class="d-flex align-center" style="gap: 40px;">
        <div class="d-flex gap15">
          <v-menu v-if="downloadReport" offset-y bottom>
            <template v-slot:activator="{ on, attrs }">
              <button type="button" class="wg-download-btn" v-bind="attrs" v-on="on">
                <i class="material-icons-outlined" style="font-size: 1rem;">file_download</i>
                <span>Download as</span>
                <i class="material-icons-outlined" style="font-size: 1.1rem;">expand_more</i>
              </button>
            </template>
            <v-list>
              <v-list-item link @click="downloadReport(sourceType, 'pdf')">
                <v-list-item-title>PDF</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="downloadReport(sourceType, 'word')">
                <v-list-item-title>Word</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="downloadReport(sourceType, 'zip')">
                <v-list-item-title>Zip (.html + images)</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <button v-else type="button" class="wg-download-btn" disabled>
            <i class="material-icons-outlined" style="font-size: 1rem;">file_download</i>
            <span>Download as</span>
            <i class="material-icons-outlined" style="font-size: 1.1rem;">expand_more</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhiteGloveEditorFooter",
  props: {
    downloadReport: {
      type: Function,
      default: null,
    },
    sourceType: {
      type: [Number, String],
      required: true,
    },
    // Dirty flag: true -> "Save" (action needed), false -> "Saved!".
    needsToSave: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-writer-info-footer {
  border-top: 1px solid var(--border, #e4e4e4);
  padding: 10px 20px;
  background: #fff;
  font-family: "Mulish", system-ui, sans-serif;
}
/* Save button: orange primary while dirty, soft "Saved!" state otherwise. */
.wg-save-btn {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: var(--pop-orange, #ff5700);
  border: 1px solid var(--pop-orange, #ff5700);
  border-radius: 7px;
  padding: 8px 16px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(255, 87, 0, 0.25);
  transition: all 0.15s;

  &:hover { background: var(--pop-orange-hover, #e64e00); }
  .dirty-dot {
    width: 15px; height: 15px; border-radius: 50%;
    background: #fff; color: var(--pop-orange, #ff5700);
    font-size: 11px; font-weight: 800;
    display: inline-flex; align-items: center; justify-content: center;
  }
  &.saved {
    background: #fff; color: var(--pop-green, #25a97a);
    border-color: var(--border, #e4e4e4); box-shadow: none; cursor: default;
  }
}
.wg-soft-btn {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-2, #014751);
  background: #fff;
  border: 1px solid var(--border, #e4e4e4);
  border-radius: 7px;
  padding: 8px 14px;
  cursor: pointer;
  transition: all 0.15s;

  &:hover { background: var(--surface-2, #f7f7f7); }
}

/* v2 primary button (matches the AI Writer v2 orange CTA). */
.wg-download-btn {
  font-family: inherit;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: var(--pop-orange, #ff5700);
  border: none;
  border-radius: 7px;
  padding: 9px 18px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(255, 87, 0, 0.25);
  transition: all 0.15s;

  &:hover:not(:disabled) {
    background: var(--pop-orange-hover, #e64e00);
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
